import(/* webpackMode: "eager" */ "/var/www/Name-Arcane/src/app/favorites/page.tsx");
